<template>
  <b-card no-body class="mb-1" v-if="isVerified">
    <b-card-header header-tag="header" class="p-3" role="tab">
      <span class="m-1">Verifikasi Email</span>
      <b-button v-b-toggle.accordion-6 variant="yellow" class="chevron">
        <span class="when-open">
          <b-icon icon="chevron-up" />
        </span>
        <span class="when-closed">
          <b-icon icon="chevron-down" />
        </span>
      </b-button>
    </b-card-header>

    <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <div class="col text-center mt-5">
          <p><strong>{{ msg }}</strong></p>
          <ValidationProvider v-slot="{ errors }" name="Password saat ini" rules="required">
            <b-form-input v-model="email" v-if="isVerified" type="email" class="text-center" required></b-form-input>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
          <br>
          <b-button v-if="isVerified" variant="primary" @click="sendEmail">Verifikasi Email</b-button>
        </div>
      </b-card-body>
    </b-collapse>

    <!-- Success modal for all confirmation  -->
    <b-modal size="sm" v-model="successModal" hide-footer hide-header>
      <div class="d-block text-center">
        <b-icon :icon="icon" animation="throb" :variant="iconColor" style="width: 120px; height: 120px;"></b-icon>
        <h3>{{ modalText }}</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" block @click="successModal = false">Tutup</b-button>
        </div>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import User from '../../api/user'

export default {
  name: 'VerifikasiEmail',
  data() {
    return {
      currentUser: '',
      isVerified: false,
      msg: '',
      successModal: false,
      modalText: '',
      icon: '',
      iconColor: '',
      email: ''

    }
  },
  created() {
    if (!this.$store.state.auth.user) {
      this.$router.push('/login')
    } else {
      this.currentUser = this.$store.state.auth.user
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      User.show(this.currentUser.info.id)
        .then(res => {
          if (res.data.meta.code == 200) {
            let userData = res.data.data

            if (userData.email_verified_at || userData.email_verified_at != null) {
              this.msg = 'Email anda telah diverifikasi'
              this.isVerified = false
              this.email = userData.email

            } else {
              this.msg = 'Email belum diverifikasi, jika anda belum menerima email verifikasi dari kami, klik tombol dibawah ini untuk mengirim ulang verifikasi ke alamat email:'
              this.isVerified = true
              this.email = userData.email

            }
          }
        })
    },
    sendEmail() {
      const userId = {
        user_id: this.currentUser.info.id,
        email: this.email
      }
      User.resend(userId)
        .then(res => {
          if (res.data.meta.code == 200) {
            this.successModal = true
            this.modalText = 'Verifikasi Berhasil Dikirim. Cek email yang telah anda daftarkan dan ikuti petunjuknya.'
            this.icon = 'check-circle'
            this.iconColor = 'success'
          } else {
            this.successModal = true
            this.modalText = 'Gagguan server, mohon mencoba kembali beberapa saat lagi'
            this.icon = 'x-circle-fill'
            this.iconColor = 'danger'
          }
        })
        .catch(err => console.log(err))
    }
  }
}
</script>

<style scoped>
.collapsed>.when-open,
.not-collapsed>.when-closed {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/VerifikasiEmail.vue